import React from 'react';
import BaseTabComponent from "../BaseTabComponent";
import {
    adminFeeCellIndex,
    camCellIndex,
    camCheckboxCellIndex,
    computeReimbTypes,
    insuranceCellIndex,
    insuranceCheckboxCellIndex,
    mgmtCellIndex,
    mgmtCheckboxCellIndex,
    recomputeCam,
    recomputeInsurance,
    recomputeMgmt,
    recomputeTaxes,
    taxesCellIndex,
    taxesCheckboxCellIndex
} from "../../utils";
import {addCommasToNumber} from "../../../../utils";

export default class CurrentReimbursement extends BaseTabComponent {
    constructor(props) {
        super(props);

        this.defaultTableRef = React.createRef();

        this.onTableValueChange = this.onTableValueChange.bind(this);
    }

    componentDidMount() {
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);
        // Compute Reimbursement Types values
        const state = computeReimbTypes({
            result: this.props.tabs,
            tab: this.props.tab,
            precomputedValues,
            newSqft: this.props.sqFtUpdated,
            newCam: this.props.camPSFSumUpdated,
            newMgmt: this.props.mgmtUpdated,
            newInsurance: this.props.insuranceUpdated,
            newTaxes: this.props.taxesUpdated,
            reimbTypesManuallyModified: this.props.reimbTypesManuallyModified,
        });
        this.props.setState(state);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.tab !== nextProps.tab) {
            const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);
            // Compute Reimbursement Types values
            const state = computeReimbTypes({
                result: this.props.tabs,
                tab: this.props.tab,
                precomputedValues,
                newSqft: this.props.sqFtUpdated,
                newCam: this.props.camPSFSumUpdated,
                newMgmt: this.props.mgmtUpdated,
                newInsurance: this.props.insuranceUpdated,
                newTaxes: this.props.taxesUpdated,
                reimbTypesManuallyModified: this.props.reimbTypesManuallyModified,
            });
            this.props.setState(state);
        }
    }

    onTableValueChange(tableIdentifier, rowCode, event, columnIndex, precomputedValues) {
        const isCurrentTab = this.props.tab.includes('current');
        const tabs =  isCurrentTab ? [this.props.tab, this.props.tab , 'proforma-reimbursement-tab' , 'proforma-reimbursement-tab'] : new Array(2).fill(this.props.tab);
        const tables = isCurrentTab ? new Array(4).fill(tableIdentifier) : new Array(2).fill(tableIdentifier);
        const rowIds = isCurrentTab ? new Array(4).fill(rowCode) : new Array(2).fill(rowCode);

        if (event.currentTarget.type === 'checkbox' || Object.prototype.hasOwnProperty.call(event.currentTarget, 'checked')) {
            const checked = event.currentTarget.checked;

            if (tableIdentifier === 'reimbursement-types' && columnIndex === camCheckboxCellIndex) {
                const camValue = recomputeCam({
                    tab: this.props.tab,
                    tabs: this.props.tabs,
                    precomputedValues,
                    index: rowCode,
                    newCheckbox: checked,
                });
                const mgmtValue = recomputeMgmt({
                    tab: this.props.tab,
                    tabs: this.props.tabs,
                    precomputedValues,
                    index: rowCode,
                    newCam: camValue,
                });
                const values = [checked, camValue, mgmtValue];
                const columnIds = [columnIndex, camCellIndex, mgmtCellIndex];
                tabs.splice(2, 0, this.props.tab);
                tables.push(tableIdentifier);
                rowIds.push(rowCode);
                if (isCurrentTab) {
                    tabs.push('proforma-reimbursement-tab');
                    tables.push(tableIdentifier);
                    rowIds.push(rowCode);
                    values.push(checked, camValue, mgmtValue);
                    columnIds.push(columnIndex, camCellIndex, mgmtCellIndex);
                }
                this.props.valuesChange({
                    tabs,
                    tables,
                    rowIds,
                    values,
                    columnIds,
                    reimbTypesManuallyModified: true,
                });
                return;
            }

            if (tableIdentifier === 'reimbursement-types' && columnIndex === mgmtCheckboxCellIndex) {
                const mgmtValue = recomputeMgmt({
                    tab: this.props.tab,
                    tabs: this.props.tabs,
                    precomputedValues,
                    index: rowCode,
                    newCheckbox: checked,
                });
                const values = [checked, mgmtValue];
                const columnIds = [columnIndex, mgmtCellIndex];
                if (isCurrentTab) {
                    values.push(checked, mgmtValue);
                    columnIds.push(columnIndex, mgmtCellIndex);
                }
                this.props.valuesChange({
                    tabs,
                    tables,
                    rowIds,
                    values,
                    columnIds,
                    reimbTypesManuallyModified: true,
                });
                return;
            }

            if (tableIdentifier === 'reimbursement-types' && columnIndex === insuranceCheckboxCellIndex) {
                const insuranceValue = recomputeInsurance({
                    tab: this.props.tab,
                    tabs: this.props.tabs,
                    precomputedValues,
                    index: rowCode,
                    newCheckbox: checked,
                });
                const values = [checked, insuranceValue];
                const columnIds = [columnIndex, insuranceCellIndex];
                if (isCurrentTab) {
                    values.push(checked, insuranceValue);
                    columnIds.push(columnIndex, insuranceCellIndex);
                }
                this.props.valuesChange({
                    tabs,
                    tables,
                    rowIds,
                    values,
                    columnIds,
                    reimbTypesManuallyModified: true,
                });
                return;
            }

            if (tableIdentifier === 'reimbursement-types' && columnIndex === taxesCheckboxCellIndex) {
                const taxesValue = recomputeTaxes({
                    tab: this.props.tab,
                    tabs: this.props.tabs,
                    precomputedValues,
                    index: rowCode,
                    newCheckbox: checked,
                });
                const values = [checked, taxesValue];
                const columnIds = [columnIndex, taxesCellIndex];
                if (isCurrentTab) {
                    values.push(checked, taxesValue);
                    columnIds.push(columnIndex, taxesCellIndex);
                }
                this.props.valuesChange({
                    tabs,
                    tables,
                    rowIds,
                    values,
                    columnIds,
                    reimbTypesManuallyModified: true,
                });
                return;
            }

            this.props.valueChange({
                tab: this.props.tab,
                table: tableIdentifier,
                row: rowCode,
                value: checked,
                columnIndex,
            });
        } else {
            const value = event.currentTarget.value;
            const reimbTypesManuallyModified = tableIdentifier === 'reimbursement-types' && [camCellIndex, mgmtCellIndex, insuranceCellIndex, taxesCellIndex].includes(columnIndex);
            let cam = null, adminFee = null;

            if (tableIdentifier === 'reimbursement-types' && columnIndex === camCellIndex)
                cam = value;
            if (tableIdentifier === 'reimbursement-types' && columnIndex === adminFeeCellIndex)
                adminFee = value;
            if (!this.props.reimbTypesManuallyModified && (cam || adminFee)) {
                const mgmtValue = recomputeMgmt({
                    tab: this.props.tab,
                    tabs: this.props.tabs,
                    precomputedValues,
                    index: rowCode,
                    newAdminFee: adminFee,
                    newCam: cam,
                });
                const values = [value, mgmtValue];
                const columnIds = [columnIndex, mgmtCellIndex];
                if (isCurrentTab) {
                    values.push(value, mgmtValue);
                    columnIds.push(columnIndex, mgmtCellIndex);
                }
                this.props.valuesChange({
                    tabs,
                    tables,
                    rowIds,
                    values,
                    columnIds,
                    reimbTypesManuallyModified,
                });
                return;
            }

            if (this.props.tab === 'current-reimbursement-tab') {
                this.props.valuesChange({
                    tabs: ['current-reimbursement-tab', 'proforma-reimbursement-tab'],
                    tables: [tableIdentifier, tableIdentifier],
                    rowIds: [rowCode, rowCode],
                    values: [value, value],
                    columnIds: [columnIndex, columnIndex],
                    reimbTypesManuallyModified
                });
                return;
            }

            this.props.valueChange({
                tab: this.props.tab,
                table: tableIdentifier,
                row: rowCode,
                value,
                columnIndex,
                reimbTypesManuallyModified
            });
        }
    }

    static renderStaticValueCell(tabs, cell, domKey, isHighlighted, highlightType, rowIndex, precomputedValues) {
        if (cell.empty) {
            return (<td className='value-cell empty' key={domKey}/>)
        }
        const displayValue = cell.getComputedValue(tabs, rowIndex, precomputedValues).displayValue;
        return (
            <td className={`${(displayValue === '-' ? 'center-dashes' : '')} value-cell ${isHighlighted ? highlightType : ''} ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')}`}
                key={domKey}>
                <span className='text value'>{displayValue}</span>
                {cell.tooltip ? <span className='cell-tooltip'>{cell.tooltip}</span> : null}
            </td>
        );
    }

    renderEditableValueCell(tableIdentifier, rowKey, cell, columnIndex, isHighlighted, highlightType, forceStatic, precomputedValues) {
        if (forceStatic || cell.forceStatic) {
            return (
                <td className={`value-cell ${isHighlighted ? highlightType : ''} ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')} ${cell.forceStatic ? 'force-static' : '' }`}
                    key={`${rowKey}-${columnIndex}`}>
                    <span className="text value">
                        {cell.value && cell.unit === '$' ? cell.unit : null}
                        {cell.value && cell.code === 'RR_SUITE_CODE' ? cell.value : cell.value ? addCommasToNumber(cell.value) : null}
                        {cell.value && cell.unit !== '$' ? cell.unit : null}
                    </span>
                </td>
            )
        }

        if (cell.type === 'boolean') {
            return (
                <td className={`value-cell checkbox-cell`} key={`${rowKey}-${columnIndex}`}>
                    <input type="checkbox" checked={cell.value}
                           onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex, precomputedValues)}/>
                </td>
            )
        }

        return (
            <td className={`value-cell ${isHighlighted ? highlightType : ''} editable-cell ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')}`}
                key={`${rowKey}-${columnIndex}`}>
                <label
                    className={`${cell.type} ${(cell.type === 'number' && (cell.unit === '$' || cell.unit === '%' || cell.unit === 'SF' || cell.unit === 'Acres' || cell.unit === 'Years' || cell.unit === 'bps')) ? 'formatted-number-label' : ''}`}>
                    <input value={cell.value}
                           onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex, precomputedValues)}
                           type={cell.type !== 'date' ? cell.type : null}
                           placeholder={cell.type === 'date' ? 'MM/DD/YYYY' : (cell.unit || cell.placeholder)}/>
                    <div className="input-display-value">
                        {cell.value && cell.unit === '$' ? cell.unit : null}
                        {cell.value ?
                            tableIdentifier === 'reimbursement-types' && [camCellIndex, mgmtCellIndex, insuranceCellIndex, taxesCellIndex].includes(columnIndex) ?
                                Number(cell.value).toFixed(2) : addCommasToNumber(cell.value)
                            : null}
                        {cell.value && cell.unit !== '$' ? (cell.unit === 'Acres' || cell.unit === 'SF' ? ` ${cell.unit}` : cell.unit) : null}
                        </div>
                </label>
            </td>
        );
    }

    renderMatrixTable(tables, tableIdentifier, precomputedValues, forceStaticCells) {
        const table = tables[tableIdentifier];

        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            let rowIsHighlighted = false;
            let rowHighlightType = 'highlighted';

            if (row.highlightable) {
                rowIsHighlighted = row.isHighlighted(this.props.tabs, key);
                if (row.highlightType) {
                    rowHighlightType += '-' + row.highlightType;
                }
            }

            return <tr key={key} className={key}>
                {row.valueCells.map((cell, index) => {
                    if (cell === null) {
                        return <td key={index} className='invisible'/>
                    }

                    if (cell.hidden) {
                        return;
                    }

                    let isHighlighted = rowIsHighlighted;
                    let highlightType = rowHighlightType;
                    if (cell.highlightable) {
                        isHighlighted = cell.isHighlighted(this.props.tabs, key);
                        if (cell.highlightType) {
                            highlightType += '-' + cell.highlightType;
                        }
                    }

                    if (cell.editable) {
                        return this.renderEditableValueCell(tableIdentifier, key, cell, index, isHighlighted, highlightType, forceStaticCells, precomputedValues);
                    } else {
                        const domKey = `${key}-${index}`;
                        return CurrentReimbursement.renderStaticValueCell(this.props.tabs, cell, domKey, isHighlighted, highlightType, key, precomputedValues);
                    }
                })}
            </tr>
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>
                {table.headerRow && table.headerRow.length ?
                    <tr>{table.headerRow.map((cell, index) => {
                        if (cell === null) {
                            return <td className='header-cell empty' key={index}/>
                        }
                        return (
                            <td className='header-cell' key={index}>
                                <div className='text'>{cell}</div>
                            </td>
                        )
                    })}</tr>
                    : null
                }

                {tableRows}

                {table.footerRow && table.footerRow.valueCells && table.footerRow.valueCells.length ?
                    <tr className='footer-row'>{Object.keys(table.footerRow.valueCells).map((key) => {
                        const cell = table.footerRow.valueCells[key];
                        if (cell) {
                            return (
                                <td key={key}>
                                    <div className='text'>{cell.getComputedValue(tables).displayValue}</div>
                                </td>
                            );
                        }
                        return <td className='invisible' key={key}/>;
                    })}</tr>
                    : null
                }
                </tbody>
            </table>
        )
    }


    onTableScroll(event) {
        const mainTable = event.target;
        const scrollTop = mainTable.scrollTop;
        const scrollLeft = mainTable.scrollLeft;
        const topHeader = document.getElementById('table-top');
        const leftColumn = document.getElementById('table-left');

        topHeader.style.transform = `translateX(-${scrollLeft}px)`;
        leftColumn.style.transform = `translateY(-${scrollTop}px)`;
    }


    render() {
        const rrTab = this.props.tab.includes('proforma') ? this.props.tabs['proforma-rr-tab'] : this.props.tabs['current-rr-tab'];
        const reimbursementTab = this.props.tabs[this.props.tab];

        // Computing heavily-used values at the start of the render.
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);

        return (
            <div className="CurrentRR CurrentReimbursement">

                <div className="title-container">
                    {BaseTabComponent.renderTableContainer(rrTab.tables[''], [
                        this.renderMatrixTable(rrTab.tables, 'location-date-information', precomputedValues)
                    ])}
                </div>

                <div className="full-table">
                    <div className="top-left">
                        {this.renderMatrixTable(rrTab.tables, 'top-left', precomputedValues)}
                    </div>
                    <div className="top" id="table-top">
                        {this.renderMatrixTable(reimbursementTab.tables, 'header', precomputedValues)}
                    </div>

                    <div className="left" id="table-left">
                        <div>
                            {this.renderMatrixTable(rrTab.tables, 'general-information', precomputedValues, true)}
                        </div>
                        {this.renderMatrixTable(rrTab.tables, 'sumed-general-information', precomputedValues)}
                    </div>

                    <div className="main-table" onScroll={this.onTableScroll}>
                        <div className="default-tables" ref={this.defaultTableRef}>
                            {this.renderMatrixTable(reimbursementTab.tables, 'detailed-information', precomputedValues)}
                            {this.renderMatrixTable(reimbursementTab.tables, 'sumed-detailed-information', precomputedValues)}
                        </div>

                        <div className="helper-tables">
                            {this.renderMatrixTable(reimbursementTab.tables, 'reimbursement-types', precomputedValues)}
                            {this.renderMatrixTable(reimbursementTab.tables, 'reimbursable-op-ex', precomputedValues)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
